var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsIntegrations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integrations__State=Integrations, Type=Enabled",
    className: "integrations__State=Integrations, integrations__Type=Enabled"
  }, /*#__PURE__*/React.createElement("g", {
    id: "integrations__vector 1",
    className: "integrations__vector integrations__1",
    clipPath: "url(#integrations__clip0_19883_46611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "integrations__Vector",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.735 1.354c.392 0 .71.314.71.703V5.76a.707.707 0 0 1-.71.703.707.707 0 0 1-.71-.703V2.057c0-.389.318-.703.71-.703Zm6.676 0c.392 0 .71.314.71.703V5.76a.707.707 0 0 1-.71.703.707.707 0 0 1-.71-.703V2.057c0-.389.317-.703.71-.703ZM3.982 7.984c0-.388.318-.703.71-.703h14.61c.393 0 .71.315.71.703a.707.707 0 0 1-.71.703H18.7c.196 3.093-.585 5.301-1.856 6.768a6.399 6.399 0 0 1-4.076 2.17v4.318a.707.707 0 0 1-.71.703.707.707 0 0 1-.71-.703V17.64a6.2 6.2 0 0 1-4.096-2.138c-1.268-1.47-2.049-3.695-1.886-6.815h-.673a.707.707 0 0 1-.71-.703Zm2.806.703c-.165 2.894.56 4.761 1.544 5.902a4.76 4.76 0 0 0 3.708 1.672h.018c1.194 0 2.642-.49 3.708-1.722.987-1.14 1.71-2.989 1.51-5.852H6.788Z",
    className: "integrations__Vector",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "integrations__clip0_19883_46611",
    className: "integrations__clip0_19883"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.477.75h17.046v22.5H3.477z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsIntegrations);
export default __webpack_public_path__ + "static/media/sidebar-icons-integrations.ad13d589cb1ca6fbbaa6fe1ed7b5ad8b.svg";
export { ForwardRef as ReactComponent };